import axiosInstance from '@/services/axios'

const searchProduct = (instId, params) => axiosInstance.get(`/institute/${instId}/inventory/product/search`, { params: params })

export { searchProduct }
